var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form-builder',{attrs:{"schemas":_vm.licenseFields,"formValues":_vm.editingValues || []},on:{"formFieldChanged":_vm.handleFormFieldChanged,"validationChanged":_vm.handleValidationChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }